<template>
  <div :title="`${selectedValue}/${getMaxValue}`"
       @mouseleave="resetRateValue($event)"
       class="flex items-center">

    <div v-if="renderMode === 2">
      <input @input="rate($event.target.value, $event)"
             :value="value"
             type="range"
             class="w-full appearance-none rounded-lg h-1 p-0 bg-green-500 focus:outline-none focus:ring-0 focus:shadow-none"
             :min="getMinValue"
             :max="getMaxValue"
             :step="step"
             :disabled="mode === 'view'"/>
    </div>

    <svg v-else
         v-for="rating in ratingRange"
         :key="rating"
         :class="`h-${starsSize} w-${starsSize}`"
         @mouseover="hoverStar(rating, $event)"
         @mouseleave="mouseLeftStar($event)"
         @click="rate(rating, $event)"
         xmlns="http://www.w3.org/2000/svg" class="flex-shrink-0" viewBox="0 0 20 20" aria-hidden="true">
      <defs v-if="rating > stepRoundedValue && (rating - currentValue) < step">
        <linearGradient :set="percentGrad = getDeltaPartInPercent(stepRoundedValue, currentValue, step)"
                        :id="`grad-${percentGrad}`"
                        x1="0" x2="100%" y1="0" y2="0">
          <stop :offset="`${percentGrad}%`" :stop-color="activeColor"/>
          <stop :offset="`${percentGrad}%`" :stop-color="inactiveColor"/>
        </linearGradient>
      </defs>
      <path
          v-if="rating <= stepRoundedValue"
          :fill="activeColor"
          d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
      <path
          v-else-if="(rating - currentValue) < step"
          :fill="`url(#grad-${percentGrad})`"
          d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
      <path
          v-else
          :fill="inactiveColor"
          d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
    </svg>

  </div>
</template>

<script>
export default {
  name: "StarRating",
  components: {},
  emits: ['update:value', 'update:comment'],
  props: {
    'value': {
      type: Number,
      default: 5,
    },
    'comment': {
      type: String,
      default: '',
    },
    'minValue': {
      type: Number,
      default: 1,
    },
    'maxValue': {
      type: Number,
      default: 5,
    },
    'step': {
      type: Number,
      default: 1,
    },
    'label': {
      type: String,
      default: '',
    },
    'mode': {
      type: String,
      default: 'view',
    },
    'starsSize': {
      type: Number,
      default: 5,
    },
    'renderMode': {
      type: Number,
      default: 1,
    }
  },
  data() {
    return {
      inactiveColor: 'rgb(209 213 219)',
      activeColor: 'rgb(250 204 21)',

      currentValue: this.value,
      currentComment: this.comment,

      selectedValue: this.value,
    }
  },
  methods: {
    rate(rateValue, event) {
      if (this.mode !== 'edit') {
        return;
      }

      if (rateValue <= this.maxValue && rateValue >= this.minValue) {
        this.selectedValue = rateValue;
        this.currentValue = rateValue;
      }
      console.log('rate')
    },
    hoverStar(rateValue, event) {
      if (this.mode !== 'edit') {
        return;
      }
      if (rateValue <= this.maxValue && rateValue >= this.minValue) {
        // this.star_desc = this.ratingdescription[star - 1];
        this.currentValue = rateValue;
      }

      console.log('hoverStar')
    },
    mouseLeftStar(event) {
      if (this.mode !== 'edit') {
        return;
      }
      // if (this.stars) {
      //   this.star_desc = this.ratingdescription[this.stars - 1];
      //   return this.star_desc;
      // } else {
      //   this.star_desc = "";
      // }
      console.log('mouseLeftStar')
    },
    resetRateValue(event) {
      if (this.mode !== 'edit') {
        return;
      }

      this.currentValue = this.selectedValue;
    },

    getDeltaPartInPercent(roundedValue, value, step) {
      const decimalPart = value - roundedValue;
      if (decimalPart <= 0) {
        return 0;
      }

      return ((decimalPart / step) * 100.0).toFixed(2);
    }
  },
  computed: {
    ratingRange() {
      let range = [];
      for (let i = this.getMinValue; i <= this.getMaxValue; i += this.step) {
        range.push(i);
      }
      return range;
    },
    stepRoundedValue() {
      return Math.floor(this.currentValue / this.step) * this.step;
    },
    getMaxValue() {
      return Math.max(this.minValue, this.maxValue);
    },
    getMinValue() {
      return Math.min(this.minValue, this.maxValue);
    }
  },
  watch: {
    selectedValue(newValue, oldValue) {
      this.$emit('update:value', newValue)
    },
    currentComment(newComment, oldComment) {
      this.$emit('update:comment', newComment)
    }
  }
}
</script>